export default __webpack_public_path__ + "static/media/Checked.363332f5.svg";